var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollectcopyicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.24963 7.5C5.24963 6.25736 6.25699 5.25 7.49963 5.25H14.2496C15.4923 5.25 16.4996 6.25736 16.4996 7.5V14.25C16.4996 15.4926 15.4923 16.5 14.2496 16.5H7.49963C6.25699 16.5 5.24963 15.4926 5.24963 14.25V7.5ZM7.49963 6.75C7.08542 6.75 6.74963 7.08579 6.74963 7.5V14.25C6.74963 14.6642 7.08542 15 7.49963 15H14.2496C14.6638 15 14.9996 14.6642 14.9996 14.25V7.5C14.9996 7.08579 14.6638 6.75 14.2496 6.75H7.49963Z",
    fill: "#334155"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 3C3.55109 3 3.36032 3.07902 3.21967 3.21967C3.07902 3.36032 3 3.55109 3 3.75V10.5C3 10.6989 3.07902 10.8897 3.21967 11.0303C3.36032 11.171 3.55109 11.25 3.75 11.25C4.16421 11.25 4.5 11.5858 4.5 12C4.5 12.4142 4.16421 12.75 3.75 12.75C3.15326 12.75 2.58097 12.5129 2.15901 12.091C1.73705 11.669 1.5 11.0967 1.5 10.5V3.75C1.5 3.15326 1.73705 2.58097 2.15901 2.15901C2.58097 1.73705 3.15326 1.5 3.75 1.5H10.5C11.0967 1.5 11.669 1.73705 12.091 2.15901C12.5129 2.58097 12.75 3.15326 12.75 3.75C12.75 4.16421 12.4142 4.5 12 4.5C11.5858 4.5 11.25 4.16421 11.25 3.75C11.25 3.55109 11.171 3.36032 11.0303 3.21967C10.8897 3.07902 10.6989 3 10.5 3H3.75Z",
    fill: "#334155"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectcopyicon);
export default __webpack_public_path__ + "static/media/collectcopyicon.9e85e61b9e5ef292a5f0f83029ce3061.svg";
export { ForwardRef as ReactComponent };